module.exports = "/images/lifestyle-inq.png?1f3b82f75e037f16d554bd431486c701";